import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_229: DocMigration = {
  maxSchemaVersion: "0.0.229",
  description: "New master plan settings",
  apply(json: any) {
    // migrate presets
    for (const presetId in json.presets) {
      const preset = json.presets[presetId];

      if (preset.planSettings) {
        preset.masterPlanSettings = {
          ...preset.planSettings,
        };

        delete preset.planSettings;
      }
    }

    // create master plan settings
    for (const settingsId in json.settings) {
      const settings = json.settings[settingsId];

      if (settings.type !== "PLAN_SETTINGS") {
        continue;
      }

      const masterPlanSettings = {
        type: "MASTER_PLAN_SETTINGS",
      };

      const addVisibilityFlag = (flag: string) => {
        if (settings[flag] !== undefined) {
          masterPlanSettings[flag] = settings[flag];
        }
      };

      addVisibilityFlag("includeBasementFloorPlan");
      addVisibilityFlag("includeFoundationPlans");
      addVisibilityFlag("includeHVACPlans");
      addVisibilityFlag("includePlumbingPlans");
      addVisibilityFlag("includeUtilityPlans");

      const masterPlanSettingsId = uid();
      (json.settings[masterPlanSettingsId] as any) = {
        ...masterPlanSettings,
        entityType: "SETTINGS",
        id: masterPlanSettingsId,
        parentId: settings.parentId,
        sortIndex: 0,
      };
    }

    return json;
  },
};

export default migration_0_0_229;
